<div  class="w-p-100 flex flex-row">
  <particle-vertical-menu
    *ngIf="data.input.showVerticalMenu"
    [selectedMenu]="selectedMenu$"
    [menuItems]="menuItems$"
    [indirectMenuItemClickedEvent]="indirectMenuItemClickedEvent.asObservable()"
    (menuClicked)="menuClicked($event)"
  ></particle-vertical-menu>
  <ng-template #dynamicComponent></ng-template>
</div>
